import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { InventoryTypeService } from '../proxy/planning/controllers/inventory-type.service';

FieldBuilder.setNamespace('Planning');

export const TEAM_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.Team.Name')
    .required()
    .maxLength(100)
    .build(),
  FieldBuilder.foreignKey(
    'inventoryTypeId',
    'Entity.InventoryType',
    InventoryTypeService
  )
    .displayFromNested('inventoryType.name')
    .sortBy('inventoryType.name')
    .required()
    .build(),
];

export const TEAM_CONFIG = {
  entityName: 'Team',
  localizationKey: 'Planning::Entity.Team',
  fields: TEAM_FIELDS,
  permission: 'PlanningInventory.Teams',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Inventory + MENU_NAME_SUFFIX,
};
